(() => {
  function initialise(root) {
    if (root.dataset.editorialReady) return;
    root.dataset.editorialReady = 'true';
    const prose = root.querySelector('[data-va-editorial-prose]');
    const toc = root.querySelector('[data-va-editorial-toc]');
    const list = root.querySelector('[data-va-editorial-links]');
    if (!prose || !toc || !list) return;
    const desktop = window.matchMedia('(min-width: 990px)');
    toc.open = desktop.matches;
    desktop.addEventListener('change', event => { toc.open = event.matches; });
    const headings = [...prose.querySelectorAll('h2')];
    if (!list.children.length) {
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = `va-read-${index + 1}`;
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent;
        item.append(link);
        list.append(item);
      });
      toc.hidden = !headings.length;
    }
    prose.querySelectorAll('table').forEach(table => {
      if (table.closest('.va-editorial__table-scroll')) return;
      const wrapper = document.createElement('div');
      wrapper.className = 'va-editorial__table-scroll';
      wrapper.setAttribute('role', 'region');
      wrapper.setAttribute('aria-label', table.getAttribute('aria-label') || root.querySelector('h1').textContent);
      wrapper.tabIndex = 0;
      table.before(wrapper);
      wrapper.append(table);
    });
    list.addEventListener('click', event => {
      const link = event.target.closest('a');
      if (!link || !link.hash) return;
      const target = document.getElementById(decodeURIComponent(link.hash.slice(1)));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      history.replaceState(null, '', link.hash);
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    });
    if ('IntersectionObserver' in window) {
      const linkObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          list.querySelectorAll('a').forEach(link => {
            if (link.hash === `#${entry.target.id}`) link.setAttribute('aria-current', 'location');
            else link.removeAttribute('aria-current');
          });
        });
      }, { rootMargin: '-130px 0px -55% 0px', threshold: 0 });
      headings.forEach(heading => linkObserver.observe(heading));
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const revealObserver = new IntersectionObserver(entries => entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }), { threshold: 0.08 });
        [...prose.querySelectorAll('figure'), ...root.querySelectorAll('[data-va-editorial-reveal]')].forEach(node => {
          node.setAttribute('data-va-editorial-reveal', '');
          revealObserver.observe(node);
        });
      }
    }
  }
  function start() { document.querySelectorAll('[data-va-editorial]').forEach(initialise); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
